import React from "react";
import { useParams, Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { CustomTooltip } from "../../components/CustomTooltip";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import Pagination from "../Constant/Pagination";
import { getBusActivePassesApi } from "../../services/TransportService";
import { useState, useEffect } from "react";
import format from "date-fns/format";
import { PiExportBold } from "react-icons/pi";
import { CancelRequest } from "../../services/AxiosInstance";
import { getEmployeePassLog } from "../../services/Employeeservice";
const EmployeePassLog = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [exportloading, setExportloading] = useState(false);
  const [param, setParam] = useState({
    query: "",
    page: "1",
    page_size: "10",
  });
  const getdata = () => {
    setLoading(true);
    getEmployeePassLog(id, param)
      .then((res) => {
        setData(res?.data?.results);
        setTotal(res.data?.count || 0);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getdata();
  }, [param, id]);
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  return (
    <div>
      <div className="d-flex justify-content-end p-2 mb-2">
        <div className="d-flex gap-1">
          <DebounceSearchInput handleSearchChange={handleSearchChange} />
        </div>
      </div>

      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : data.length === 0 ? (
        <div className="p-2 text-center">There are no records found.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-hover fs-6 align-middle mb-0">
            <thead className="custom-thead table-light">
              <tr>
                <th>Pass ID</th>
                <th>Route no.</th>
                <th>Shift</th>
                <th>Stop</th>
                <th>Status</th>
                <th>Reason</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => {
                return (
                  <tr key={idx}>
                    <td>{row?.bus_pass?.pass_id}</td>
                    <td>{row?.route?.route_number || "N/A"}</td>
                    <td>{row?.shift || "N/A"}</td>
                    <td>{row?.stop || "N/A"}</td>
                    <td>{row?.log_status || "N/A"}</td>
                    <td>{row?.reason || "N/A"}</td>
                    <td>
                      {row?.requested_at
                        ? format(row?.requested_at, "dd MMM yyy")
                        : "N/A"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      {!loading && data && data.length > 0 && (
        <div className="px-2 border-top">
          <Pagination
            currentPage={param.page}
            recordsPage={param.page_size}
            dataLength={total}
            handlePagination={handlePageChange}
          />
        </div>
      )}
    </div>
  );
};

export default EmployeePassLog;
